import { Component } from '@angular/core';
import { ConfigService } from '@core/services';

@Component({
  selector: 'app-page-unknown-error',
  templateUrl: './page-unknown-error.component.html',
  styleUrl: './page-unknown-error.component.scss',
  standalone: false,
})
export class PageUnknownErrorComponent {
  main_site_url: string;

  constructor(private readonly configService: ConfigService) {
    this.main_site_url = this.configService.postLogoutUri;
  }
}
